

import './App.css';
import {useEffect, useRef, useState} from "react";
import { useUser } from "./hooks/useUser";
import photo_img from './photo.png';
import bg1_img from './bg1.png';
import GlassyButton from "./GlassyButton";
import AnimatedLetters from "./AnimatedLetters";



import heart_img from './heart.png';
import hello_img from './hello.png';


import {AnimatePresence, motion} from 'framer-motion';





const DEFAULT_LANG = "en";
const SUPPORTED_LANGS = ["en", "de", "fr", "it", "es"];

const translations = {
    en: {
        questions: [
            "Have you ever met women who make the first move?",
            "Are you interested in a place where girls send photos first?",
            "Are you ready for a one-night stand with a woman?",
            "Right now, there is an opportunity to check this place."
        ],

        question: "Question",
        yes: "YES",
        no: "NO",
        continue: "CONTINUE",
        title1: "FIND A DATE",
        title2: "TONIGHT",
        subtitle: "Join MeetDate",
        join: "JOIN NOW!"
    },

    de: {
        questions: [
            "Hast du schon einmal Frauen getroffen, die den ersten Schritt machen?",
            "Interessiert dich ein Ort, an dem Frauen zuerst Fotos schicken?",
            "Bist du bereit für einen One-Night-Stand mit einer Frau?",
            "Jetzt hast du die Möglichkeit, diesen Ort kennenzulernen."
        ],

        question: "Frage",
        yes: "JA",
        no: "NEIN",
        continue: "WEITER",
        title1: "DATE FINDEN",
        title2: "HEUTE",
        subtitle: "Zu MeetDate",
        join: "JETZT STARTEN"
    },

    fr: {
        questions: [
            "As-tu déjà rencontré des femmes qui font le premier pas ?",
            "Es-tu intéressé par un endroit où les filles envoient d'abord leurs photos ?",
            "Es-tu prêt pour une aventure d'un soir avec une femme ?",
            "Tu as maintenant la possibilité de découvrir cet endroit."
        ],

        question: "Question",
        yes: "OUI",
        no: "NON",
        continue: "CONTINUER",
        title1: "TROUVE UN DATE",
        title2: "CE SOIR",
        subtitle: "Rejoins MeetDate",
        join: "COMMENCER"
    },

    it: {
        questions: [
            "Hai mai incontrato donne che fanno la prima mossa?",
            "Ti interessa un posto dove le ragazze inviano prima le foto?",
            "Sei pronto per un'avventura di una notte con una donna?",
            "In questo momento hai l'opportunità di scoprire questo posto."
        ],

        question: "Domanda",
        yes: "SÌ",
        no: "NO",
        continue: "CONTINUA",
        title1: "TROVA UN DATE",
        title2: "STASERA",
        subtitle: "Unisciti a MeetDate",
        join: "INIZIA ORA"
    },

    es: {
        questions: [
            "¿Alguna vez has conocido a mujeres que dan el primer paso?",
            "¿Te interesa un lugar donde las chicas envían fotos primero?",
            "¿Estás listo para una aventura de una noche con una mujer?",
            "Ahora mismo tienes la oportunidad de conocer este lugar."
        ],

        question: "Pregunta",
        yes: "SÍ",
        no: "NO",
        continue: "CONTINUAR",
        title1: "BUSCA UNA CITA",
        title2: "HOY",
        subtitle: "Únete a MeetDate",
        join: "EMPEZAR"
    }
};





function App() {





    const tgLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
        ?.toLowerCase()
        ?.split("-")[0];

    const lang = SUPPORTED_LANGS.includes(tgLang)
        ? tgLang
        : DEFAULT_LANG;

    const t = translations[lang] || translations.en;




    const [checkedRedirect, setCheckedRedirect] = useState(false);

    const ENABLE_REDIRECT_COOKIE = false;

    useUser();

    useEffect(() => {
        const tg = window.Telegram?.WebApp;

        const alreadyVisited = localStorage.getItem("offer_redirected");

        if (ENABLE_REDIRECT_COOKIE && alreadyVisited === "true") {

            const startParam =
                tg?.initDataUnsafe?.start_param || "revisit";

            const username =
                tg?.initDataUnsafe?.user?.username || "nousername";

            const url =
                `https://sexxdates.site/Ftryv2` +
                `?sub_id_2=${encodeURIComponent(startParam)}` +
                `&sub_id_3=${encodeURIComponent(username)}`;
            // const url = `https://sexxdates.site/Ftryv2`;

            // const url = `https://sexxdates.site/Ftryv2`;

            window.location.replace(url);

            return;
        }

        setCheckedRedirect(true);
    }, []);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        tg?.enableClosingConfirmation();
        tg?.disableVerticalSwipes();
        tg?.expand();

        // alert(tg.initDataUnsafe.start_param)
    }, []);






    const pointsRef = useRef(null);

    const scrollToPoints = () => {
        pointsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };













    const [modal, setModal] = useState(false);

    const questions = t.questions;

    const [questionIndex, setQuestionIndex] = useState(0);

    const [loading, setLoading] = useState(false);

    const handleLinkPress = () => {
        if (loading) return;

        setLoading(true);

        if (ENABLE_REDIRECT_COOKIE) {
            localStorage.setItem("offer_redirected", "true");
        }

        const tg = window.Telegram?.WebApp;

        const startParam =
            tg?.initDataUnsafe?.start_param || "unknown";

        const username =
            tg?.initDataUnsafe?.user?.username || "nousername";

        const url =
            `https://sexxdates.site/Ftryv2` +
            `?sub_id_2=${encodeURIComponent(startParam)}` +
            `&sub_id_3=${encodeURIComponent(username)}`;
        // const url = `https://sexxdates.site/Ftryv2`;

        setTimeout(() => {
            const a = document.createElement("a");
            a.href = url;
            a.rel = "noopener noreferrer";

            document.body.appendChild(a);
            a.click();
            a.remove();
        }, 10);
    };


    if (!checkedRedirect) {
        return (

            <motion.div
                className="page-loader"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: 0.25, ease: "easeOut"}}
            >
                <motion.div
                    className="page-loader-backdrop"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                />

                <motion.div
                    className="page-loader-content"
                    initial={{opacity: 0, scale: 0.92, y: 4}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    exit={{opacity: 0, scale: 0.96, y: 2}}
                    transition={{duration: 0.25, ease: "easeOut"}}
                >
                    <div className="spinner"></div>
                </motion.div>
            </motion.div>

        );
    }

    return (
        <div className="app">


            <section
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                        "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                    color: "#fff",
                    padding: "40px 20px",
                    fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                }}
            >
                <div
                    style={{
                        maxWidth: "1200px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "60px",
                        flexWrap: "wrap",
                    }}
                >
                    <div style={{ flex: 1, minWidth: "320px" }}>
          <span
              style={{
                  display: "inline-block",
                  background: "#FACC15",
                  color: "#111827",
                  padding: "6px 14px",
                  borderRadius: "999px",
                  fontWeight: 600,
                  marginBottom: "20px",
              }}
          >
            Premium Wheels
          </span>

                        <h1
                            style={{
                                fontSize: "56px",
                                lineHeight: 1.1,
                                margin: "0 0 24px",
                                fontWeight: 800,
                            }}
                        >
                            Royal Stars
                        </h1>

                        <p
                            style={{
                                fontSize: "20px",
                                lineHeight: 1.7,
                                color: "#CBD5E1",
                                maxWidth: "550px",
                                marginBottom: "36px",
                            }}
                        >
                            Premium alloy wheels designed for performance, durability and
                            style. Upgrade your vehicle with high-quality wheels engineered
                            for a perfect balance of strength, precision and modern design.
                        </p>

                        <a
                            href="https://example.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "16px 34px",
                                borderRadius: "12px",
                                background: "#FACC15",
                                color: "#111827",
                                textDecoration: "none",
                                fontWeight: 700,
                                fontSize: "18px",
                                transition: "0.2s",
                            }}
                        >
                            View Collection →
                        </a>
                    </div>

                    <div
                        style={{
                            flex: 1,
                            minWidth: "320px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=900"
                            alt="Royal Stars Wheels"
                            style={{
                                width: "100%",
                                maxWidth: "520px",
                                borderRadius: "24px",
                                objectFit: "cover",
                                boxShadow: "0 25px 60px rgba(0,0,0,.45)",
                            }}
                        />
                    </div>
                </div>
            </section>







        </div>
    );
}

export default App;